import api from "./api";

export async function getCurrentUser() {
  const res = await api.get("/auth/user");
  return res.data.data;
}
export async function getAdminsFull() {
  // liste 
  const res = await api.get("/user");
  const users = res.data.data;

  if (!Array.isArray(users)) return [];

  const admins = users.filter((u) => u.id_role === "R01");

  //show(id)
  const detailedAdmins = await Promise.all(
    admins.map(async (admin) => {
      const detail = await api.get(`/user/${admin.id}`);
      return detail.data.data;
    })
  );

  return detailedAdmins;
}

export async function getAdmins() {
    const res = await api.get("/user");
    const users = res.data.data;
    if (!Array.isArray(users)) return [];
    return users.filter((u) => u.id_role === "R01");
}
